import { useCallback, useMemo } from 'react'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import useRegionAwareOfferList from 'hooks/Offers/useRegionAwareOfferList'
import { encodeSearchParams } from 'lib/search/searchUtils'
import { ANYWHERE_SEARCH_ITEM } from 'constants/search'
import config from 'constants/config'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from '../constants/luxPlusMonthTakeoverConstants'

function LuxPlusMonthTakeoverBestHotelOffersCarousel() {
  const renderItalic = useCallback((chunks: ReactNode) => <i>{chunks}</i>, [])

  // Region: campaign-tagged + member-priced (most relevant)
  const regionRequest = useMemo(() => ({
    filters: {
      offerTypes: ['tactical_ao_hotel'] as Array<App.OfferListOfferType>,
      campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
      luxPlusFeatures: ['Member prices'] as Array<App.LuxPlusFeatureFilter>,
    },
    limit: 5,
  }), [])

  // Region backup: tops up the region result when campaign tag alone is too narrow
  const regionBackupRequest = useMemo(() => ({
    filters: {
      offerTypes: ['tactical_ao_hotel'] as Array<App.OfferListOfferType>,
      luxPlusFeatures: ['Member prices'] as Array<App.LuxPlusFeatureFilter>,
    },
    limit: 5,
  }), [])

  // Anywhere: same filters as regionRequest — an unfiltered fill let non-campaign, non-member offers dilute the carousel
  const anywhereRequest = useMemo(() => ({
    filters: regionRequest.filters,
    limit: 15,
  }), [regionRequest.filters])

  const offerList = useRegionAwareOfferList(regionRequest, anywhereRequest, regionBackupRequest)

  const searchQuery = useMemo(() => encodeSearchParams({
    searchItem: ANYWHERE_SEARCH_ITEM,
    rooms: [config.search.defaultOccupants],
    filters: regionRequest.filters,
  }), [regionRequest.filters])

  return (
    <OfferCardCarouselSection
      title={<FormattedMessage
        id="kVZhMKvgQhrg1S7kIDk1"
        defaultMessage="<i>Bigger savings</i> on great hotel offers"
        description="Section title for the LuxPlus+ Month campaign landing page hotel offers carousel, with 'Bigger savings' shown in italics"
        values={{ i: renderItalic }}
      />}
      filters={regionRequest.filters}
      overrideOfferList={offerList}
      allLink={`/search?${searchQuery.toString()}`}
      hideWhenEmpty
      tileStyle="card-default"
      tileSize="medium"
    />
  )
}

export default LuxPlusMonthTakeoverBestHotelOffersCarousel
